import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAuthenticationAccessService = ( createDecorator('IAuthenticationAccessService'));
export { IAuthenticationAccessService };
